import React from "react";
import { LogoImage } from "../../_static/images";
import { Wrapper } from "./styled-components";

export const Logo = (props: React.ImgHTMLAttributes<HTMLImageElement>) => (
  <Wrapper {...props} src={LogoImage} alt="Mozantech Logo" />
);
